export const localFontList: {
  fileName: string;
  fontId: string;
  name: string;
  type: 'ttf' | 'otf';
}[] = [
  {
    fileName: 'local-1',
    fontId: 'local-1',
    name: 'Alegreya',
    type: 'ttf',
  },
  {
    fileName: 'local-2',
    fontId: 'local-2',
    name: 'AmaticSC',
    type: 'ttf',
  },
  {
    fileName: 'local-3',
    fontId: 'local-3',
    name: 'Anton',
    type: 'ttf',
  },
  {
    fileName: 'local-4',
    fontId: 'local-4',
    name: 'BebasNeue',
    type: 'ttf',
  },
  {
    fileName: 'local-5',
    fontId: 'local-5',
    name: 'Cinzel',
    type: 'ttf',
  },
  {
    fileName: 'local-6',
    fontId: 'local-6',
    name: 'Cookie',
    type: 'ttf',
  },
  {
    fileName: 'local-7',
    fontId: 'local-7',
    name: 'FatCow',
    type: 'ttf',
  },
  {
    fileName: 'local-8',
    fontId: 'local-8',
    name: 'Feltful',
    type: 'otf', // local-8.otf
  },
  {
    fileName: 'local-9',
    fontId: 'local-9',
    name: 'GreatVibes',
    type: 'ttf',
  },
  {
    fileName: 'local-10',
    fontId: 'local-10',
    name: 'HenriDidot',
    type: 'otf', // local-10.otf
  },
  {
    fileName: 'local-11',
    fontId: 'local-11',
    name: 'Kanya',
    type: 'ttf',
  },

  {
    fileName: 'local-13',
    fontId: 'local-13',
    name: 'Lemon Tuesday',
    type: 'otf', // local-13.otf
  },
  {
    fileName: 'local-14',
    fontId: 'local-14',
    name: 'Meddon',
    type: 'ttf',
  },
  {
    fileName: 'local-15',
    fontId: 'local-15',
    name: 'StampatelloFaceto',
    type: 'otf', // local-15.otf
  },
  {
    fileName: 'local-16',
    fontId: 'local-16',
    name: 'Kurland',
    type: 'otf', // local-15.otf
  },
];
